<template>
  <v-menu bottom offset-y z-index="1000">
    <template #activator="{ on, attrs }">
      <v-btn
        color="techBlueDark"
        outlined
        class="mr-2"
        v-bind="attrs"
        v-on="on"
      >
        {{ $t("management-balances") }}
        <v-icon right>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list>
      <ManagementBalancesListDialog />
      <ManagementBalanceCreationDialog :business-plan-id="businessPlanId" />
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from "vuex";
import ManagementBalancesListDialog from "@/components/dialogs/ManagementBalancesListDialog.vue";
import ManagementBalanceCreationDialog from "@/components/dialogs/ManagementBalanceCreationDialog.vue";

export default {
  name: "ManagementBalanceBtnDropdown",
  components: {
    ManagementBalanceCreationDialog,
    ManagementBalancesListDialog,
  },
  data() {
    return {
      createDialog: false,
    };
  },
  computed: {
    ...mapGetters({
      businessPlan: "businessPlan/getBusinessPlan",
      businessPlanReady: "businessPlan/isReady",
    }),
    businessPlanId() {
      return this.businessPlanReady ? this.businessPlan.id : null;
    },
  },
};
</script>
